import React, { Fragment, useState } from 'react';
import { Menu } from 'antd';
import styled from 'styled-components';
import Text from './Text';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetCurrentLoadBalance } from '@src/store/slice/balanceUploadSlice';
import AdminMenus from './MenusAdmin';

const { SubMenu, ItemGroup, Item } = Menu;

const CustomMenu = styled(Menu)`
  background-color: #fff;
  border-right: 0;

  li.ant-menu-item-selected {
    background-color: #f2f5f7 !important;
    box-shadow: inset 6px 0 0 0 #f72717;
  }
  li.ant-menu-item-selected:after {
    border-right: none;
  }

  li.sub-menu-item-clicked {
    background-color: #fff !important;
    box-shadow: inset 6px 0 0 0 #fff;

    &:hover {
      background-color: #f8fafb !important;
      box-shadow: inset 6px 0 0 0 #f727174d;
    }
  }

  li.ant-menu-item-group {
    height: 48px;
    margin: 0 36px;
    display: flex;
    align-items: center;
  }

  li.menu-last-child {
    box-shadow: none;
  }

  li.ant-menu-item:active,
  .ant-menu-submenu-title:active {
    background: none;
  }
`;

const CustomItem = styled(Item)`
  padding: 0 !important;
  margin: 0 !important;

  :hover {
    background-color: #f8fafb;
    box-shadow: inset 6px 0 0 0 #f727174d;
  }
  :active {
    color: #ffffff !important;
  }
`;

const CustomSubMenu = styled(SubMenu)`
  .ant-menu-sub.ant-menu-inline {
    background: #fff !important;
  }

  .ant-menu-submenu-title {
    margin-top: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;

    :hover,
    :active,
    :hover > .ant-menu-submenu-arrow,
    :active > .ant-menu-submenu-arrow {
      color: #303845 !important;
    }
  }

  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow {
    color: #303845;
    width: 4px;
    height: 8px;
  }

  :hover,
  :active {
    color: #ffffff !important;
  }

  .ant-menu-submenu-arrow {
    right: 46px !important;
  }

  .ant-menu-sub > li:first-child {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .ant-menu-inline .ant-menu-item,
  .ant-menu-inline .ant-menu-submenu-title {
    width: 100% !important;
  }
`;

const CustomItemGroup = styled(ItemGroup)(
  ({ color }) => `
  .ant-menu-item-group-title{
    font-family: UbuntuMedium, sans-serif;
    color: ${color};
    padding: 0 0;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    font-size: 14px;
    letter-spacing: normal;
  }
`,
);

const MenuItemText = styled.div`
  margin: 0 36px;
  border-bottom: solid 1px #eaeaea;

  display: flex;
  white-space: initial;
  height: 48px;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }

  span {
    font-family: UbuntuMedium, sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #3c4655;
  }
`;

const MenuSubItemText = styled.div`
  margin: 0 0 0 66px;
  box-shadow: none;
  display: flex;
  white-space: initial;
  height: 48px;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }

  .sub-menu-text-dot {
    width: 4px;
    height: 4px;
    margin: 10px 8px 10px 0;
    background-color: #3f4957;
    border-radius: 50%;
  }

  span {
    font-family: UbuntuMedium, sans-serif;
    //padding-left: 12px;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #3c4655;
  }
`;

const Menus = ({ setCollapsed = () => {} }) => {
  const history = useHistory();
  const { selectedKey, menus } = useSelector((state) => state?.menus);
  const { isAdmin } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const [openKeys, setOpenKeys] = useState([]);

  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);

  if (isAdmin) {
    return <AdminMenus setCollapsed={setCollapsed} />;
  }

  const handleClick = (e) => {
    if (currentLoadBalance?.vouId !== 94) {
      dispatch(resetCurrentLoadBalance());
    }
    if (e.item?.props.style?.paddingLeft === 24) {
      setOpenKeys([]);
    }
    setCollapsed(false);
    history.push(e?.key);
  };

  const onOpenChange = (keys) => {
    const lastItem = keys[keys.length - 1];
    setOpenKeys([lastItem]);
  };

  return (
    <CustomMenu
      data-testid="menus-test"
      onClick={handleClick}
      mode="inline"
      selectedKeys={selectedKey}
      onOpenChange={onOpenChange}
      openKeys={openKeys}
    >
      {menus?.map((menu, index) => {
        return (
          menu?.userSubMenus?.length > 0 && (
            <Fragment key={menu?.text}>
              <CustomItemGroup title={<Text t={menu?.text} />} color={menu?.textColor} />
              {menu?.userSubMenus?.map((subMenu) => {
                if (subMenu?.isParent) {
                  return (
                    <CustomSubMenu
                      key={`${menu?.id}-${subMenu?.key}`}
                      className={'menu-last-child'}
                      title={
                        <MenuItemText>
                          <span>
                            <Text t={subMenu?.text} />
                          </span>
                        </MenuItemText>
                      }
                    >
                      {subMenu?.userSubMenus?.map((subSubMenu) => {
                        const path = location.pathname;
                        const isClickedItem = path === subSubMenu?.key;

                        return (
                          <CustomItem
                            key={subSubMenu?.key}
                            className={`${!isClickedItem ? 'sub-menu-item-clicked' : ''}`}
                            style={{
                              pointerEvents: isClickedItem ? 'none' : 'auto',
                            }}
                          >
                            <MenuSubItemText>
                              <p className={'sub-menu-text-dot'} />
                              <span>
                                <Text t={subSubMenu?.text} />
                              </span>
                            </MenuSubItemText>
                          </CustomItem>
                        );
                      })}
                    </CustomSubMenu>
                  );
                } else {
                  const path = location.pathname;
                  const isClickedItem = path === subMenu?.key;

                  return (
                    <CustomItem
                      key={subMenu?.key}
                      className={`${!isClickedItem ? 'sub-menu-item-clicked' : ''}`}
                      style={{
                        pointerEvents: isClickedItem ? 'none' : 'auto',
                      }}
                    >
                      <MenuItemText>
                        <span>
                          <Text t={subMenu?.text} />
                        </span>
                      </MenuItemText>
                    </CustomItem>
                  );
                }
              })}
            </Fragment>
          )
        );
      })}
    </CustomMenu>
  );
};

export default Menus;
